import { autoserialize, inheritSerialization } from 'cerialize';

import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class BillingSummary extends AbstractModel {
  @autoserialize
  reservationId: number;

  @autoserialize
  baseRiderFee: null;

  @autoserialize
  mileageSurcharge: number;

  @autoserialize
  additionalPassengerSurcharge: number;

  @autoserialize
  totalRiderFee: number;

  @autoserialize
  driverDistanceRate: number;

  @autoserialize
  driverTimeRate: number;

  @autoserialize
  driverBaseFare: number;

  @autoserialize
  driverDistanceFare: number;

  @autoserialize
  driverTimeFare: number;

  @autoserialize
  driverIncentive: number;

  @autoserialize
  driverCommissionAmount: number;

  @autoserialize
  distanceMiles: number;

  @autoserialize
  durationMinutes: number;

  @autoserialize
  durationSeconds: number;

  @autoserialize
  grossFare: number;

  @autoserialize
  totalFare: number;

  @autoserialize
  platformFee: number;

  @autoserialize
  invoiceAmount: number;

  @autoserialize
  tollAmount: number;
}
